<template>
  <div>
    <vs-input
        v-validate="'required|min:3'"
        data-vv-validate-on="blur"
        name="login"
        icon-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Login"
        v-model="login"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('login') }}</span>

    <vs-input
        v-validate="'required|min:4|max:15'"
        data-vv-validate-on="blur"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="password"
        class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <div class="flex flex-wrap justify-between my-5">
        <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Запомнить меня</vs-checkbox> -->
        <!-- <router-link to="/pages/forgot-password">Забыли пароль?</router-link> -->
        <vs-button class="mb-3" type="flat" @click="forgetMynex">Забыли пароль?</vs-button>
    </div>
    <div class="flex flex-wrap justify-between mb-3">
      <vs-button  type="border" @click="registerMynex">Регистрация</vs-button>
      <vs-button :disabled="!validateForm" @click="loginMynex">Войти</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      login: '',
      password: '',
      // login: 'admin',
      // password: 'admin260784',
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.login != '' && this.password != '';
    },
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.getLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    loginMynex() {
      console.log('loginMynex');
      this.$auth.login(this.login, this.password, this.checkbox_remember_me);
    },
    registerMynex() {
      this.$vs.loading()
      window.location.href = 'https://mynex.ru/register.html';
      // this.$router.push('https://mynex.ru/register.html').catch(() => {})
    },
    forgetMynex() {
      this.$vs.loading()
      window.location.href = 'https://mynex.ru/forget.html';
      // this.$router.push('https://mynex.ru/register.html').catch(() => {})
    },
  }
}

</script>

